import { DscrStatus, HousingPayment, RentalUnit } from '../types/dscr'

export function formatCurrency(value: number, fractionDigits = 2): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}

export function formatRatio(value: number): string {
  if (!Number.isFinite(value)) return '—'
  return value.toFixed(4)
}

export function totalRent(units: RentalUnit[]): number {
  return units.reduce((sum, unit) => sum + (unit.monthlyRent || 0), 0)
}

export function totalHousingPayment(payment: HousingPayment): number {
  return (
    payment.principalAndInterest +
    payment.homeownersInsurance +
    payment.propertyTax +
    payment.mortgageInsurance +
    payment.other
  )
}

export function calculateDscr(units: RentalUnit[], payment: HousingPayment): number {
  const housing = totalHousingPayment(payment)
  if (housing <= 0) return 0
  return totalRent(units) / housing
}

export function dscrStatus(dscr: number): DscrStatus {
  if (dscr >= 1.25) return 'strong'
  if (dscr >= 1.0) return 'pass'
  if (dscr >= 0.75) return 'marginal'
  return 'fail'
}

export function formatTimestamp(iso: string): string {
  const date = new Date(iso)
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
